import { render, staticRenderFns } from "./OrkRenameDialog.vue?vue&type=template&id=a85daa64&"
import script from "./OrkRenameDialog.vue?vue&type=script&lang=js&"
export * from "./OrkRenameDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports